import PaymentPanel from "./PaymentPanel";

export default PaymentPanel;
